import { DEV, ENV_PATH } from '@/common/js/const'
let HOST_NAME = DEV ? '//cs-cross.didiglobal.com' : `//${window.location.host}`;
if(document.domain.includes("sim")){
	HOST_NAME = `//${window.location.host}/d-server-ngw/cs_global`
}
const QIANKUN_CONFIG = [
	// {
	// 	name: 'optimus',
	// 	entry: `${HOST_NAME}/static/optimus/index.html?_t=${new Date().getTime()}`,
	// 	activeRule: `/optimus`,
	// }, {
	// 	name: 'optimus2',
	// 	entry: `${HOST_NAME}/static/optimus2/index.html?_t=${new Date().getTime()}`,
	// 	activeRule: `/optimus2`,
	// },
	{
		name: 'kfcommon-fe-i18n',
		entry: `${HOST_NAME}/static/kfcommon/index.html?_t=${new Date().getTime()}${DEV ? '&&test=1' : ''}`,
		activeRule: `/ark_fe`,
	}
	// , {
	// 	name: 'cs-tool-system',
	// 	entry: `${HOST_NAME}/cs-tool-system/index.html?_t=${new Date().getTime()}`,
	// 	activeRule: `/tool`,
	// }
	, {
		name: 'cs-online',
		entry: `${HOST_NAME}/static/im/index.html?_t=${new Date().getTime()}`,
		activeRule: `/im`,
	}
	, {
		name: 'no-permission',
		entry: `${HOST_NAME}/`,
		activeRule: `/no-permission`,
	}, {
		name: 'cs-ticket-system',
		entry: `${HOST_NAME}/cs-ticket-system/index.html?_t=${new Date().getTime()}`,
		activeRule: `/ticket`,
	},
	// ,{
	// 	name: 'cs-config-system',
	// 	entry: `${HOST_NAME}/cs-config-system/index.html?_t=${new Date().getTime()}`,
	// 	activeRule: `/cs-config-system`,
	// },{
    {
		name: 'customer-management',
		entry: `${HOST_NAME}/customer-management/index.html?_t=${new Date().getTime()}`,
		activeRule: `/customer-management`,
	},
	{
		name: 'cs-workbench-main',
		entry: `https://static.didiglobal.com/ibt/cs-workbench-main-old/index.html?_t=${new Date().getTime()}`,
		activeRule: `/cs-workbench-main`,
	}
]

export default QIANKUN_CONFIG

export const menuIconName = {
	"satisfaction": 'icon-Badge', // 调查问卷
}

export const languageList = {
	'zh-CN': '中文',
	'en-US': 'English',
	'pt-BR': 'Português',
	'es-MX': 'Español',
	'ja-JP': '日本語',
	'ru-RU': 'Русский',
	'ar-EG': 'عربي',
}

// 新工单处理 menu 配置
export const newCsTicket = ['/work-bench-list', '/ticket-lists']
